<script>
export let backend;
let offers = [];

function csv() {
  let csvContent = "data:text/csv;charset=utf-8,Game, Item, Descriptor, Provider, Price, Count\n" + offers
    .map(o => o.game + ',' + o.item + ',' + o.descriptor + ',' + o.provider + ',' + o.price + ',' + o.count)
    .join("\n");
  let encodedUri = encodeURI(csvContent);
  let link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "avg-offers.csv");
  document.body.appendChild(link); // Required for FF
  link.click();
}

backend.getAvgOffersPerDescriptor().then(o => {
  offers = o;
});

</script>
<main>
<div id="app">
  <button type="submit" class="btn btn-light mb-3" on:click|preventDefault ={csv}>CSV</button>
  <table class="table table-sm table-dark table-striped">
    <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">Game</th>
      <th scope="col">Item</th>
      <th scope="col">Descriptor</th>
      <th scope="col">Provider</th>
      <th scope="col">Price</th>
      <th scope="col">Count</th>
    </tr>
    </thead>
    <tbody>
    {#each offers as offer, index}
    <tr>
      <th scope="row">{index}</th>
      <td>{offer.game}</td>
      <td>{offer.item}</td>
      <td>{offer.descriptor}</td>
      <td>{offer.provider}</td>
      <td>{offer.price}</td>
      <td>{offer.count}</td>
    </tr>
    {/each}
    </tbody>
  </table>
</div>
</main>